import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  products: any[] = [];
  loading: boolean = false;
  categoryTitle: string = '';
  parseAvailableSizes(value: string | null | undefined): string[] {
    if (!value) return [];
    return String(value)
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }

  constructor(
    private api: SharedService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug');
    if (slug) {
      this.categoryTitle = this.formatSlug(slug);
      this.loadProducts(slug);
    } else {
      // If no slug, fall back to all products or redirect
      this.router.navigate(['/brand']);
    }
  }

  private formatSlug(slug: string): string {
    return slug
      .replace(/[-_]+/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }

  async loadProducts(slug: string): Promise<void> {
    try {
      this.loading = true;
      const encoded = encodeURIComponent(slug);
      const res: any = await this.api.get(`product/list?category_slug=${encoded}`);
      console.log(res);
      if (res?.status === 'success' && res?.data) {
        this.products = res.data;
      }
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      this.loading = false;
    }
  }

  getImg(path: string): string {
    if (!path) {
      return 'assets/no-image.png';
    }
    // If path already starts with http/https, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // Otherwise, append to base URL
    return this.api.imageBase + path;
  }

  viewProduct(slugs: string): void {
    this.router.navigate(['/products-details', slugs]);
  }
}